export default __webpack_public_path__ + "static/811-46d80da969551f01ac6a79b99a549548.gif";